export default {"src":"/_next/static/image/public/images/ic_down_arrow_green.73538bfe1f1eba84d58fbe632918900d.svg","height":7,"width":13};